export default __webpack_public_path__ + "static/media/EyeSlash.180903ef.svg";